import InputSigarusNumber from '../InputSigarusNumber'
import inputExtend from './inputExtend'

function formatDecimals (number, decimals) {

	var d = ',';
	var t = '.';
	var c = decimals;
	var n = number,
		c = isNaN(c = Math.abs(c)) ? 2 : c,
		d = d == undefined ? "." : d,
		t = t == undefined ? "," : t,
		s = n < 0 ? "-" : "",
		i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
		j = (j = i.length) > 3 ? j % 3 : 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) + " " : "");
}

let hookInput = {
	hook: 'beforeSave',
	callback: function (comp, val) {

		if(comp.$attrs.input.limits && ( val >= comp.$attrs.input.limits.max || val < comp.$attrs.input.limits.min)) {
			throw ({
				message: `Valor mínimo ${comp.$attrs.input.limits.min} y máximo ${comp.$attrs.input.limits.max}`, 
				type: 'Error'
			})
		} 
	}
}

const decimales = [0, 2, 4].reduce((o, d) => {

	return {
		...o,
		...[['E', '€'], ['D', '$'], ['P', '%'], 'cms'].reduce((o2, s) => {

			const t = Array.isArray(s) ? s[0] : s

			const v = Array.isArray(s) ? s[1] : s
			
			o2[`number${d}decimals`] = inputExtend(InputSigarusNumber, [hookInput], {
				methods: {

					$render (val) { return `${formatDecimals(val,d)}` }

				}
			})

			o2[`number${d}decimals${t}prepend`] = inputExtend(InputSigarusNumber, [hookInput], {
				props: {
					precision: {
						type: Number,
						default: d
					}
				},
				methods: {

					$render (val) { return `${v} ${formatDecimals(val,d)}` }
					//$render (val) { return `${v} ${val}` }

				}
			})

			o2[`number${d}decimals${t}append`] = inputExtend(InputSigarusNumber, [hookInput], {
				props: {
					precision: {
						type: Number,
						default: d
					}
				},
				methods: {

					$render (val) { return `${formatDecimals(val,d)} ${v}` }
					//$render (val) { return `${val} ${v}` }

				}
			})

			return o2

		}, {})
	}

}, {})

export default {
	number: InputSigarusNumber,
	...decimales
}
